// Precios de la suscripción, centralizados (antes vivían hardcodeados dentro de PerfilPanel).
export const PRECIOS = { mensual: 590, anual: 5900 };

export const MONEDA = "UYU";

// Precio por defecto según la duración del plan pagado (1 mes o 12 meses).
export function precioPorMeses(meses) {
  return Number(meses) === 12 ? PRECIOS.anual : PRECIOS.mensual;
}

// Formatea un monto para mostrar. Ej: 5900 → "$5.900"
export function formatearMonto(monto) {
  return `$${(Number(monto) || 0).toLocaleString("es-UY")}`;
}
